import React,{useState,useEffect, useContext} from 'react';
import { ModalContainer,
  UIcon,
  IconContainer,
  StyleLabel,
  MainContentContainer1,
  SubmitContainer,
  StyleButton
 } from './CreateAdminUser';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import { useSettingModal } from '../../../../hooks/Context';
import { useDispatch } from 'react-redux';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { NotificationContext } from '../../../../providers/notification';
import { string } from 'yup';
import { userInfo } from 'os';

interface Payload {
  Id: Number
  UserId: string;
  RoleId: string;
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface RoleProps {
  Id: string;
  Name: string;
  NormalizedName: string;
};

interface RoleResponse {
  data: RoleProps[];
};

const AddSubordinateRole = (props:any) => {
  const [roleByUserId, setRoleByUserid] = useState<any[]>([]);

    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const userData  = props.data ? props.data : null;
    const name = userData ? `${userData.FirstName} ${userData.MiddleName ? userData.MiddleName : ''} ${userData.LastName}` : '';
    const [userRole, setUserRole] = useState('');
    const { setShowModal } = useSettingModal();
    const remove = props.remove ? props.remove : false;
    const roleData = props.roleData ? props.roleData : null;
    //const roleByUserData = props.roleByUserData ? props.roleByUserData : null;
    
    const { showNotification } = useContext(NotificationContext);

    const handleChange = (event: SelectChangeEvent<typeof userRole>) => {
      const {
        target: { value },
      } = event;
      setUserRole(
        // On autofill we get a stringified value.
        typeof value === 'string' ? value : '',
      );
    };

    const getSubordinateRoleByUserId = async () => {
      return (await (apiCall().get(`Administration/MyToSurbodinateRoleAsync/${userData?.UserId}`))) as RoleResponse;
    };
  
    const getRoleByUserIdMutation = useMutation(['get-roleById'], getSubordinateRoleByUserId, {retry: 0});
  
    // const roleError = getRoleByUserIdMutation?.error as AxiosError;
    // const roleErrorMessage = roleError?.message;
  
    const roleHandler = async () => {
        try {
            const data = await getRoleByUserIdMutation.mutateAsync()
            setRoleByUserid(data?.data)
        } catch (error: any){
  
        }
    }
  
    useEffect(() => {
        roleHandler()
    }, [userData])
   
    const AddAdminUserToSubordinateRole = async (data: Payload) => {
      return await (apiCall().post('Administration/post/AddUserToSurbodinateRole/user', data))
    };

    const addAdminUserToRoleMutation = useMutation(['post-addadminUser-toRole'], AddAdminUserToSubordinateRole, { retry: 0 });

    const AddAdminUserToSubordinateRoleHandler = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();


      const payload: Payload = {
          UserId: userData?.UserId,
          RoleId: roleData.find((eData:any)=> eData.Name == userRole)?.Id,
          Id: 0
      };

      try {
        await addAdminUserToRoleMutation.mutateAsync(payload, {
          onSuccess: () => {
            showNotification({
              type: 'success',
              message: 'Subordinate Successfully Added To User',
            })
            queryClient.invalidateQueries(['get-admin-users'])
            setShowModal(false);
          }
        })
      }
      catch (error: any) {
        showNotification({
          type: 'error',
          message: error?.response?.data?.Message || error?.Message,
        })
      }
    };

    const removeSubordinateRole = async (data: any) => {
      return await (apiCall().delete('Administration/RemoveUserToSurbodinateRole',{data}))
    };

    const removeSubordinateRoleMutation = useMutation(['remove-adminUser-fromSubordinateRole'], removeSubordinateRole, { retry: 0 });

    const removeAdminUserFromSubordinateRoleHandler = async (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();

      const payload: Payload = {
          UserId: userData?.UserId,
          RoleId: roleByUserId.find((eData:any) => eData.RoleName == userRole)?.RoleId,
          Id: 0
      };

      try {
        await removeSubordinateRoleMutation.mutateAsync(payload, {
          onSuccess: () => {
            showNotification({
              type: 'success',
              message: 'User Successfully Removed From Subordinate Role',
            })
            queryClient.invalidateQueries(['get-admin-users'])
            setShowModal(false);
          }
        })
      }
      catch (error: any) {
        showNotification({
          type: 'error',
          message: error?.response?.data?.Message || error?.Message,
        })
      }
    };

    //filter to get roles not yet assigned to a user
    const filteredRole = roleData.filter((data1: any) => {
      return !roleByUserId.some((data2: any) => {
        return data1?.Name === data2?.Name;
      })
    });

    const filteredRole2 = roleByUserId;

    return (
      <ModalContainer>
        <div>
          <div>
            <div>
              <IconContainer><UIcon /></IconContainer>
              <span>{!remove ? 'Add Surbodinate Role' : 'Remove Subordinate Role'}</span>
              </div>
            </div>
            <MainContentContainer1 onSubmit={remove ? removeAdminUserFromSubordinateRoleHandler : AddAdminUserToSubordinateRoleHandler}>
              <div>
                <span>Admin: </span>
                <span>{name}</span>
              </div>
              <StyleLabel className='full' style={{marginTop: "15px", marginBottom: "30px"}}>
                <span>Role</span>
                <Select
                  labelId="demo-multiple-checkbox-label"
                  id="demo-multiple-checkbox"
                  //multiple
                  value={userRole}
                  onChange={handleChange}
                  input={<OutlinedInput label="Role" />}
                  renderValue={(selected) => selected}
                  MenuProps={MenuProps}
                >
                  {remove ? 
                    (filteredRole2.length > 0 && filteredRole2?.map((role: any, index: number) => (
                    <MenuItem key={index} value={role?.RoleName}>
                      <Checkbox checked={userRole.indexOf(role?.RoleName) > -1} />
                      <ListItemText primary={role?.RoleName} />
                    </MenuItem>
                  ))) : (
                    filteredRole.length > 0 && filteredRole?.map((role: any, index: number) => (
                      <MenuItem key={index} value={role?.Name}>
                        <Checkbox checked={userRole.indexOf(role?.Name) > -1} />
                        <ListItemText primary={role?.Name} />
                      </MenuItem>
                    ))
                  )}
                </Select>
              </StyleLabel>
              <SubmitContainer>
                <span onClick={() => setShowModal(false)}>Cancel</span>
                {remove ? (
                  <StyleButton 
                    style={{backgroundColor: remove ? '#DD5151' : '#11643C'}} 
                    disabled={removeSubordinateRoleMutation.isLoading}
                  >
                    {removeSubordinateRoleMutation.isLoading ? 'Removing...' : 'Remove Subordinate'}
                  </StyleButton>
                ) : (
                  <StyleButton 
                    style={{backgroundColor: remove ? '#DD5151' : '#11643C'}} 
                    disabled={addAdminUserToRoleMutation.isLoading}
                  >
                    {addAdminUserToRoleMutation.isLoading? 'Adding...' : 'Add Subordinate Role'}
                  </StyleButton>
                )}
              </SubmitContainer>
            </MainContentContainer1>

        </div>
      </ModalContainer>
    )
  }

export default AddSubordinateRole;

